import React from 'react';
import get from 'lodash/get';
import Tabs from '@components/common/Dashboard/DashboardTabs/Tabs';
import { TAB_TITLE_AI_ROADMAP } from '@utils/constants';
import { HeaderPanelWrapper } from './styled';
import { useParams } from 'react-router-dom';

interface PropTypes {
  pageType: number;
}

const HeaderPanel = (props: PropTypes) => {
  const { pageType } = props;
  const { id:currentShareId = TAB_TITLE_AI_ROADMAP } = useParams();

  return (
    <HeaderPanelWrapper>
      <Tabs currentShareId={currentShareId} pageType={pageType} />
    </HeaderPanelWrapper>
  );
};

export default HeaderPanel;
